<template>
  <v-row class="mb-auto" justify="center">
    <v-col cols="12">
      <search v-if="issearch" :items="headers" @querydata="querydata"></search>
      <v-data-table :multi-sort="false" item-key="Id"
        :headers="headers" :items="mainData" :items-per-page="limit" :options.sync="options"
        :server-items-length="countData" :loading="loading" class="elevation-1 text-no-wrap" show-group-by
        :footer-props="{ itemsPerPageText: '分页:', 'items-per-page-options':[10,20,30,50,100,-1] }">
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>评价</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-btn small :color="issearch ? 'error' : 'success'" dark class="mr-2" @click="issearch = !issearch">
              <v-icon>{{ issearch ? "mdi-magnify-close" : "mdi-magnify" }}</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <span>分值0-5</span>
          </v-toolbar>
        </template>
        <template v-slot:item.Rattext="{ item }">
          <v-tooltip bottom v-if="item.Rattext&&item.Rattext.length > 17">
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on" style="max-width: 240px;"
                class="d-inline-block text-truncate">{{ item.Rattext }}</span>
            </template>
            <span>{{ item.Rattext }}</span>
          </v-tooltip>
          <span v-else>{{ item.Rattext }}</span>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">刷新数据</v-btn>
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
  import search from "@/components/search";
  export default {
    components: {
      search,
    },
    data: function () {
      return {
        dialog: false,
        headers: [
          { text: "产品", value: "PiCier.Producter.Name", groupable: false, },
          { text: "批次", value: "PiCier.PiCi", groupable: false, },
          { text: "二维码标识", value: "EwmStr", groupable: false, },
          { text: "评分", value: "Rating", groupable: false, },
          { text: "评价内容", value: "Rattext", groupable: false, },
          // { text: "评价者IP", value: "Ip", groupable: false, },
          { text: "评价者地域", value: "IpAddr", groupable: false, },
          { text: "评价时间", value: "CreateAt", groupable: false, },
        ],
        issearch: false,
        mainData: [],
        countData: 0,
        offset: 0,
        limit: this.$store.state.glimit,
        query: "",
        exclude: "",
        sortby: "",
        order: "",
        options: {},
        loading: false,
      };
    },
    watch: {
      dialog(val) {
        val || this.close();
      },
      options: {
        handler() {
          //立即执行
          this.limit = this.options.itemsPerPage;
          this.offset = (this.options.page - 1) * this.limit;
          this.sortby = "";
          this.order = "";
          for (let index = 0; index < this.options.sortBy.length; index++) {
            this.sortby += this.options.sortBy[index] + ",";
            this.order += this.options.sortDesc[index] ? "desc," : "asc,";
          }
          if (this.sortby.length > 0) {
            this.sortby = this.sortby.slice(0, -1);
            this.order = this.order.slice(0, -1);
          }
          this.initialize();
        },
        deep: true, //对象深度监听
      },
    },
    methods: {
      querydata(query, exclude) {
        this.query = query;
        this.exclude = exclude;
        this.initialize();
      },
      initialize() {
        let data = {
          limit: this.limit,
          offset: this.offset,
        };
        if (this.query != "") {
          data.query = this.query;
        }
        if (this.exclude != "") {
          data.exclude = this.exclude;
        }
        if (this.sortby != "") {
          data.sortby = this.sortby;
          data.order = this.order;
        }
        this.loading = true;
        this.$api.getMyRatings(data).then((res) => {
          this.loading = false;
          if (res.data) {
            this.mainData = res.data;
            this.countData = res.count;
          } else {
            this.mainData = [];
            this.countData = 0;
          }
        }).catch((error) => {
          this.loading = false;
          let message = (error && error.msg) || "获取数据列表失败！";
          this.$store.commit("setsnack", {
            message,
          });
          console.error(error);
        });
      },
    },
  };
</script>